import React from "react";
import ReactGA from "react-ga";
import {Redirect} from "react-router";
import {AlertBoxComponent} from "./../Common/AlertBoxComponent";
import {SearchBoxComponent} from "./../Common/SearchBoxComponent";
import {ThumbnailComponent} from "./../Common/ThumbnailComponent";
import {ImageViewerComponent} from "./../Common/ImageViewerComponent";

import "./../../css/gallery-viewer.css";

const ERROR = "error";
const EMPTY_RESULT_MSG = 'No images matched your filter criteria! Please try again with a different keyword or with fewer keywords (Hint: use location, category, landmark and/or characteristic as keyword(s). e.g. "California", "Yosemite National Park", "Waterfalls", "Golden Gate Bridge", "Milky Way"). You may also empty the filter field to show all photos.';
const COUNTER_INC = 10;

const allPhotos = [
    { name: "drought", category: "Landscape", title: "Drought", description: "Cracked Mud Tiles on a Dried Lake Bed", location: "Death Valley National Park, USA",
      tags: " landscapes outdoors natures drought desolate dessert desert death valley national parks mud lake dried dry bed cracked tiles mountains sunrise sunset california united states usa vertical" },

    { name: "dancing-aspen", category: "Landscape", title: "Dancing Aspen", description: "Curvy Aspen Trees Seemingly Dancing in the Forest", location: "Colorado, USA",
      tags: " landscapes outdoors natures autumn falls dancing curvy groovy aspen san juan colorado co colors trees trunk forests curves" },

    { name: "superbowl-50", category: "Landscape", title: "Super Bowl 50", description: "A 6-Frame Stitched Large Panorama of San Francisco Skyline During the Super Bowl 50 Week", location: "San Francisco, California, USA",
      tags: " landscapes outdoors architectures super bowl superbowl 50 fifty san francisco bay area sfo west coast pacific california united states usa cityscapes buildings twilights night shots transamerica pyramid embarcadero beacons skylines waters panoramas panoramic" },

    { name: "cosmic-canopy", category: "Landscape", title: "Cosmic Canopy", description: "An 18-Frame Stitched Large Panorama of Glacier Point With Milky Way Arched Across the Night Sky", location: "Yosemite National Park, California, USA",
      tags: " landscapes outdoors natures cosmic canopy yosemite national parks glacier points pt california west coast united states usa valleys milkyways ways starry stars arches halfdomes domes night shots panoramas panoramic" },

    { name: "liquid-floral", category: "Landscape", title: "Liquid Floral", description: "Bluish Water of Brúarfoss", location: "Iceland",
      tags: " landscapes outdoors natures liquid florals iceland brekkuskógur europe brúarfoss bruarfoss waterfalls falls glacier blue bluish sunrises sunsets " },

    { name: "superbowl-fireworks", category: "Landscape", title: "Super Bowl 50 Fireworks", description: "Fireworks Display for Super Bowl 50 Along San Francisco Bay with Bay Bridge in the Foreground", location: "San Francisco, California, USA",
      tags: " landscapes outdoors natures architectures super bowl superbowl 50 fifty san francisco bay area sfo west coast pacific california united states usa cityscapes buildings twilights night shots transamerica pyramid embarcadero beacons skylines waters fireworks" },

    { name: "under-maple-canopy", category: "Landscape", title: "Under the Maple Canopy", description: "Japanese Maple Tree in Autumn", location: "Oregon, USA",
      tags: " landscapes outdoors natures under the maples canopy portland oregon united states usa pacific northwest japanese gardens trees mossy autumn falls colors" },

    { name: "sand-towers", category: "Landscape", title: "Sand Towers", description: "Close Up View of a Group of Tiny Sand Tufas", location: "Eastern Sierra, California, USA",
      tags: " landscapes outdoors natures sand towers mono lakes lee vinings eastern sierras california tufas deserts sands formations tufas sunrises sunsets" },

    { name: "allure", category: "Landscape", title: "Allure", description: "A Secluded Waterfall Surrounded by Basalt Amphitheater Hidden Deep in the Gorge", location: "Oregon, USA",
      tags: " landscapes outdoors natures allure abiqua scotts mills oregon columbia rivers gorge pacific northwest waterfalls basalts mossy autumn falls colors" },

    { name: "maroon-bells-autumn", category: "Landscape", title: "Autumn at Maroon Bells", description: "Alpenglow on Maroon Peaks with Fall Colors Surrounding the Lake", location: "Aspen, Colorado, USA",
      tags: " landscapes outdoors natures autumn falls maroon bells aspen snowmass colorado co peaks mountains lakes sunrises sunsets reflections waters colors trees calm" },

    { name: "lone-tree", category: "Landscape", title: "Lone Tree", description: "A Snow-Coated Withered Tree with Golden Glow Granite Wall Backdrop", location: "Yosemite National Park, California, USA",
      tags: " landscapes nature outdoors lone trees yosemite national parks california west coast united states usa valleys forests snow winter sunsets sunrises granites rocks walls foggy withered" },

    { name: "el-capitan", category: "Landscape", title: "El Capitan", description: "Golden Light on El Capitan With Fresh Coat of Snow Blanketing the River Bank", location: "Yosemite National Park, California, USA",
      tags: " landscapes nature outdoors el capitan yosemite national parks california west coast united states usa valleys snow winter sunsets sunrises granites rocks walls rivers merced" },

    { name: "strawberry-moonrise-over-ggb", category: "Landscape", title: "Moonlight Symphony", description: "Strawberry Moonrise Aligned with Golden Gate Bridge Tower on 6/10/2017", location: "San Francisco, California, USA",
      tags: " landscapes outdoors natures architectures moonlight symphony strawberry moonrises over golden gate bridges ggb san francisco sfo bay areas california west coast united states usa transamerica pyramid buildings fullmoon night shots twilights" },

    { name: "berry-veil", category: "Landscape", title: "Berry Veil", description: "Close Up View of Berry Creek Falls", location: "Big Basin, California, USA",
      tags: " landscapes outdoors natures berry veil creek saratoga big basin california bay areas west coast united states usa waterfalls close up mossy" },

    { name: "wizard-hat", category: "Landscape", title: "Wizard Hat", description: "Milky Way Core Aligned and Sat Atop a Triagular-Shaped Sea Stack", location: "Bay Area, California, USA",
      tags: " landscapes outdoors natures wizard hats west coasts bay area half moon coastal california united states usa beaches milkyways ways sea stacks martins night shots stars starry" },

    { name: "spring-purple-carpet", category: "Landscape", title: "Spring Purple Carpet", description: "Spring's Wild Owl Clovers Covering the Slope of a Hill", location: "Bay Area, California, USA",
      tags: " landscapes outdoors natures spring purple carpets livermore bay areas west coast california united states usa wildflowers flowers florals hills slopes sunsets sunrises owl clovers" },

    { name: "farm-ville", category: "Landscape", title: "Farm Ville", description: "Rolling Hills of Wheat Fields in Palouse", location: "Palouse, Washington, USA",
      tags: " landscapes outdoors natures farm ville farmville palouse washington pacific northwest united states usa hills rolling wheat fields sunrises sunsets" },

    { name: "ice-age", category: "Landscape", title: "Ice Age", description: "Inside a Mendenhall Glacier Ice Cave", location: "Juneau, Alaska, USA",
      tags: " landscapes outdoors natures ice age caves mendenhall juneau alaska united states usa waterfalls glacier blue winter winter" },

    { name: "breaking-dawn", category: "Landscape", title: "Breaking Dawn", description: "Waves Rushed In As the Sky Lit Up over Golden Gate Bridge During Sunrise", location: "San Francisco, California, USA",
      tags: " landscapes outdoors natures architectures breaking dawn san francisco bay areas west coast sfo united states usa california beaches bridges waves seascapes golden gate ggb sunsets sunrises" },

    { name: "winter-escapade", category: "Landscape", title: "Winter Escapade", description: "Frozen Waterfall Along a River Canyon in the Canadian Rockies", location: "Alberta, Canada",
      tags: " landscapes outdoors natures winter escapade galleria alberta canada jasper national parks banff canyon waterfalls frozen rivers glacier blue rockies" },

    { name: "corazon", category: "Landscape", title: "Corazon", description: "Heart Shaped Lake with Mount Shasta in the Background", location: "Mount Shasta, California, USA",
      tags: " landscapes outdoors natures corazon heart castle lakes mount mt mountains shasta northern california united states usa west coast sunrises sunsets alpenglow shaped" },

    { name: "color-palette", category: "Landscape", title: "Color Palette", description: "Intimate View of Wheat Fields Layers", location: "Palouse, Washington, USA",
      tags: " landscapes outdoors natures colors palettes palouse washington pacific northwest united states usa steptoe butte state parks hills rolling wheat fields close up" },

    { name: "trees-in-mist", category: "Landscape", title: "Trees in Mist", description: "Forest of Pine Trees Engulfed in Morning Fog", location: "Yosemite National Park, California, USA",
      tags: " landscapes outdoors natures trees in mists yosemite national parks california west coast united states usa valleys foggy misty close up forests" },

    { name: "magical-moment", category: "Landscape", title: "Magical Moment", description: "Golden Gate Bridge Enveloped in Fog at Sunrise", location: "San Francisco, California, USA",
      tags: " landscapes outdoors nature magical moments san francisco sfo bay areas west coast california golden gate bridges ggb architectures foggy sunrises sunsets karl the" },

    { name: "inertia", category: "Landscape", title: "Inertia", description: "Moving Rocks of Racetrack Playa under the Milky Way", location: "Death Valley National Park, California, USA",
      tags: " landscapes outdoors natures inertia racetrack track playa death valleys national parks nevada united states usa deserts lakes dried milkyways ways galaxy starry stars moving sailing rocks" },

    { name: "morning-tranquility", category: "Landscape", title: "Morning Tranquility", description: "Colorful Sunrise at Bonsai Rock with Perfectly Calm Lake Water", location: "Nevada, USA",
      tags: " landscapes outdoors natures morning tranquility north lakes tahoe nevada united states usa waters rocks bonsai sunrises sunsets reflections calm colors" },

    { name: "golden-tunnel", category: "Landscape", title: "Golden Subway Tunnel", description: "Golden Light Reflected off a Tubular Canyon Wall", location: "Wilderness Area of Zion National Park, Utah, USA",
      tags: " landscapes outdoors natures golden tunnels subways utah zion national parks wilderness southwest united states usa waters pools virgin rivers" },

    { name: "golden-passage", category: "Landscape", title: "Golden Passage", description: "Raging Water of the Virgin River Cutting Through this Narrow Canyon with Ethereal Glow on the Sandstone Wall", location: "The Narrows, Zion National Park, Utah, USA",
      tags: " landscapes outdoors natures golden passages narrows zion national parks utah united states usa virgin rivers waters wilderness southwest canyons walls sandstones" },

    { name: "rock-saddles", category: "Landscape", title: "Rock Saddles", description: "Alien Looking Hoodoos Standing Precariously Against the Test of Time", location: "Utah, USA",
      tags: " landscapes outdoors natures rocks saddles hoodoos southwest utah united states usa sandstones sunrises sunsets wilderness" },

    { name: "horseshoe-bend", category: "Landscape", title: "Horseshoe Bend", description: "Horseshoe Shaped Meander of the Colorado River", location: "Page, Arizona, USA",
      tags: " landscapes outdoors natures horseshoes shoes bends page arizona southwest united states usa sunrises sunsets sandstones colorado rivers" },

    { name: "enchanted-forest", category: "Landscape", title: "Enchanted Forest", description: "Sun Beams Shined Through the Misty Redwood Forest", location: "California, USA",
      tags: " landscapes outdoors natures enchanted forests redwoods national parks del norte california west coast northern united states usa trees sunbeams beams rays sunrays" },

    { name: "moonlight-jazz", category: "Landscape", title: "Moonlight Jazz", description: "Supermoon Rose Over Golden Gate Bridge", location: "San Francisco, California, USA",
      tags: " landscapes outdoors natures moonlight jazz san francisco bay areas west coast california sfo golden gate bridges ggb hills transamerica pyramid fullmoon moonrise twilights architectures" },

    { name: "guardian", category: "Landscape", title: "The Guardian", description: "Storm Clouds Blanketing the Sky Over Pigeon Point Lighthouse", location: "Pescadero, California, USA",
      tags: " landscapes outdoors natures storm watchers pigeon points lighthouses pescadero california coastal west bay areas ocean seascapes architectures sunrises sunsets" },

    { name: "colored-dream", category: "Landscape", title: "Colored Dream", description: "Colorful Sunrise at Capitola Pier", location: "Santa Cruz, California, USA",
      tags: " landscapes outdoors natures colored colors dreams santa cruz capitola piers coastal pacific west coast bay areas california united states usa seascapes ocean beaches sunrises sunsets" },

    { name: "natures-fireworks", category: "Landscape", title: "Nature's Fireworks", description: "Sun Beam Shined through the Keyhole and Lit Up the Sea Splash", location: "Big Sur, California, USA",
      tags: " landscapes outdoors natures fireworks pfeiffer beaches big sur keyholes coastal bay areas pacific ocean seascapes rocks west coast california united states usa sunbeams beams sunrays rays splashes parks sunsets sunrises glow" },

    { name: "paradise", category: "Landscape", title: "Paradise", description: "Valley of Wild Calla Lilies at Peak Bloom", location: "Big Sur, California, USA",
      tags: " landscapes outdoors natures paradise big sur coastal west coast bay areas california calla lily lilies wildflowers flowers florals pacific ocean sunrises sunsets carpets" },

    { name: "rodeo-sunset", category: "Landscape", title: "Rodeo Sunset", description: "Retreating Waves at Rodeo Beach After the Storm", location: "Marin County, California, USA",
      tags: " landscapes outdoors natures rodeo marin coastal pacific ocean west coast california bay areas beaches seascapes sunsets sunrises rocks" },

    { name: "pathway-to-light", category: "Landscape", title: "Pathway to Light", description: "The Setting Sun Aligned with This Sea Stack Channel As Waves Rushed In", location: "California, USA",
      tags: " landscapes outdoors natures pathways to lights santa cruz davenport coastal west coast united states usa pacific ocean seascapes bay areas california beaches sunsets sunrises rocks waves" },

    { name: "natures-firefall", category: "Landscape", title: "Nature's Firefall", description: "Horsetail Falls Lit Up by the Setting Sun", location: "Yosemite National Park, California, USA",
      tags: " landscapes outdoors natures firefalls yosemite national parks valleys west coast california united states usa horsetails waterfalls falls granites rocks sunsets glow winter" },

    { name: "sf-holiday-cheer", category: "Landscape", title: "SF Holiday Cheer", description: "San Francisco Skyline with Holiday Lights Seen from Under the Bay Bridge", location: "San Francisco, California, USA",
      tags: " landscapes outdoors architectures sfo san francisco holidays cheers bay areas west coast coastal bridges california united states usa cityscapes embarcadero beacons transamerica pyramid buildings twilights" },

    { name: "heart-of-san-francisco", category: "Landscape", title: "Heart of San Francisco", description: "Traffic Going Through the Main Arteries of the City of San Francisco", location: "San Francisco, California, USA",
      tags: " landscapes outdoors architectures hearts of san francisco sfo bay areas west coast california united states usa cityscapes transamerica pyramid beacons holidays cheers buildings twilights" },

    { name: "remnant-of-a-glorious-past", category: "Landscape", title: "Remnant of a Glorious Past", description: "Shipwreck Run Aground in Point Reyes", location: "Point Reyes, California, USA",
      tags: " landscapes outdoors remnant of a glorious past inverness marin northern california west coast point reyes pt shipwrecks recks shore black and white bw" },

    { name: "midst-of-mist", category: "Landscape", title: "Midst of Mist", description: "Foggy Golden Gate Scene with the South Tower and Bay Bridge Peaking Through", location: "San Francisco, California, USA",
      tags: " landscapes nature outdoors midst of mists san francisco sfo bay areas west coast california united states usa golden gate bridges ggb karl foggy the black and white bw" },

    { name: "clean-sweep", category: "Landscape", title: "Clean Sweep", description: "Rushing Waves Swept the Beach at Natural Bridge State Park", location: "Santa Cruz, California, USA",
      tags: " landscapes nature outdoors clean sweeps santa cruz natural bridges parks coastal west coast bay areas pacific ocean seascapes united states usa water waves sunsets sunrises sea stacks rocks beaches" },

    { name: "painters-palette", category: "Landscape", title: "Painters Palette", description: "Mirror Reflection of the Alpenglow", location: "Eastern Sierra, California, USA",
      tags: " landscapes nature outdoors painters palettes eastern sierras convict lakes west coast california united states usa mountains alpenglow reflections calm water rocks pebbles" },

    { name: "quiet-path-bw", category: "Landscape", title: "Quiet Path", description: "A Peaceful Cypress Tree Tunnel Walkway Enveloped in Fog", location: "California, USA",
      tags: " landscapes nature outdoors quiet paths marin point reyes pt bay areas california west coast united states usa trees and forests black white bw foggy mists" },

    { name: "quiet-path", category: "Landscape", title: "Quiet Path", description: "A Peaceful Cypress Tree Tunnel Walkway Enveloped in Fog", location: "California, USA",
      tags: " landscapes nature outdoors quiet paths marin point reyes pt bay areas california west coast united states usa trees and forests foggy mists" },

    { name: "bay-bridge-pilings", category: "Landscape", title: "Bay Bridge Pilings", description: "Panoramic View of Bay Bridge With Old Pilings in the Foreground", location: "San Francisco, California, USA",
      tags: " landscapes outdoors bay bridges pilings areas california san francisco sfo west coast coastal united states usa cityscapes architectures panoramas panoramic twilights moonrise moonset reflections" },

    { name: "tangent", category: "Landscape", title: "Tangent", description: "View of Bonsai Rock Aligned With the Milky Way", location: "Nevada, USA",
      tags: " landscapes nature outdoors tangent lakes tahoe north nevada west coast united states usa milkyways ways bonsai rocks galaxy night shots calm water" },

    { name: "heaven-on-earth", category: "Landscape", title: "Heaven on Earth", description: "Panoramic View of Golden Gate Bridge Engulfed in Fog", location: "San Francisco, California, USA",
      tags: " landscapes outdoors nature heavens on earth san francisco sfo bay areas west coast california golden gate bridges ggb architectures foggy sunrises sunsets karl the panoramas panoramic" },

    { name: "hk-skyline", category: "Landscape", title: "Hong Kong Skyline", description: "Hong Kong Skyline During Christmas Holiday", location: "Hong Kong, China",
      tags: " landscapes outdoors architectures hong kong skylines buildings holidays lights china kowloon night shots twilights water reflections" },

    { name: "alone", category: "Landscape", title: "Alone", description: "Sea Stack Along Santa Cruz Coastline", location: "Santa Cruz, California, USA",
      tags: " landscapes nature outdoors alone santa cruz davenport coastal west coast bay areas pacific ocean seascapes united states usa water waves sunsets sunrises sea stacks rocks beaches" },

    { name: "gates-of-hope", category: "Landscape", title: "Gates of Hope", description: "Panoramic View of Golden Gate Bridge with Morning Fog Covering the Bay", location: "San Francisco, California, USA",
      tags: " landscapes outdoors nature gates of hope san francisco sfo bay areas west coast california golden gate bridges ggb architectures foggy sunrises sunsets karl the panoramas panoramic" },

    // { name: "ggb-75-anniversary", category: "Landscape", title: "Golden Gate's Diamond Jubilee", description: "Fireworks Display in Celebration of Golden Gate Bridge's 75th Anniversary", location: "San Francisco, California, USA",
    //   tags: " landscapes outdoors 75 anniversary diamonds jubilee san francisco sfo bay areas west coast california golden gate bridges ggb architectures panoramas panoramic night shots fireworks" },

    { name: "painted-ladies", category: "Landscape", title: "Painted Ladies", description: "Popular Row of Victorian Houses in Downtown San Francisco", location: "San Francisco, California, USA",
      tags: " landscapes outdoors painted ladies san francisco sfo bay areas california west coast united states usa victorian houses cityscapes architectures twilights transamerica pyramid night shots" },

    { name: "sundial-bridge", category: "Landscape", title: "Sundial Bridge", description: "A Cantilever Spar Cable-Stayed Bridge in Turtle Bay", location: "Redding, California, USA",
      tags: " landscapes outdoors sundial bridges turtle bay redding california united states usa west coast sacramento rivers twilights night shots architectures cityscapes" },

    { name: "mossbrae-paradise", category: "Landscape", title: "Mossbrae Paradise", description: "Water Cascading Down a Moss Covered Wall", location: "California, USA",
      tags: " landscapes nature outdoors mossbrae paradise waterfalls dunsmuir california west coast united states usa shasta cascades walls sacramento rivers" },

    { name: "mountain-light", category: "Landscape", title: "Mountain Light", description: "Lake View of Alpenglow on Mount Morrison", location: "Eastern Sierra, California, USA",
      tags: " landscapes nature outdoors mountains lights eastern sierras california nevada united states usa west coast convict lakes morrison alpenglow sunsets sunrises rocks water" },

    { name: "walton-lighthouse", category: "Landscape", title: "Walton Lighthouse", description: "View of Walton Lighthouse Along Santa Cruz Shores", location: "Santa Cruz, California, USA",
      tags: " landscapes nature outdoors walton lighthouses santa cruz parks coastal west coast bay areas pacific ocean seascapes united states usa water beaches sunsets sunrises rocks" }

];

export class GalleryViewerComponent extends React.Component {

    constructor(props) {
        super(props); // props: category, stopScrolling, enableScrolling
        this.state = {
            matchedPhotos: allPhotos,
            oldSearchString: "",
            numberOfDisplayedPhotos: Math.min(COUNTER_INC, allPhotos.length),
            photoInViewIndex: -1,  // denotes no photo is selected
            //stateCount: 0,
            redirectTo: null
        };

        this.handleFilterSearch = this.handleFilterSearch.bind(this);
        this.handleLoadMoreClick = this.handleLoadMoreClick.bind(this);
        this.handleViewPhoto = this.handleViewPhoto.bind(this);
        this.handleClosePhotoViewer = this.handleClosePhotoViewer.bind(this);
        this.handleViewNextPhoto = this.handleViewNextPhoto.bind(this);
        this.handleViewPreviousPhoto = this.handleViewPreviousPhoto.bind(this);
    }

    componentWillMount() {
        if (this.props.paramName) {
            let index = -1;
            const photoName = this.props.paramName.toLowerCase();

            for (let i = 0; index < 0 && i < allPhotos.length; i++) {
                if (allPhotos[i].name === photoName) {
                    index = i;  // found
                }
            }

            if (index >= 0) {
                this.setState({
                    matchedPhotos: null,
                    numberOfDisplayedPhotos: 0
                });

                let target = allPhotos.splice(index, 1);
                allPhotos.unshift(target[0]);

                this.props.stopScrolling();
                this.setState({
                    matchedPhotos: allPhotos,
                    numberOfDisplayedPhotos: Math.min(COUNTER_INC, allPhotos.length),
                    photoInViewIndex: 0
                });

                // Tracking
                ReactGA.pageview(window.location.pathname.toLowerCase());

                // Tracking
                // ReactGA.event({
                //     category: "PhotoViewer",
                //     action: "View",
                //     label: "photo-viewed: " + this.props.category.toLowerCase() + "/" + photoName
                // });
            } else {
                this.setState({
                    redirectTo: "/"
                });
            }
        } else {
            // Tracking
            ReactGA.pageview(window.location.pathname.toLowerCase());
        }
    }

    handleLoadMoreClick() {
        if (this.state.numberOfDisplayedPhotos < this.state.matchedPhotos.length) {
            this.setState({numberOfDisplayedPhotos: Math.min(this.state.numberOfDisplayedPhotos + COUNTER_INC, this.state.matchedPhotos.length)});
            // Tracking
            ReactGA.event({
                category: "Navigation",
                action: "Click",
                label: "show-more-button"
            });
        }
    }

    handleFilterSearch(searchString) {
        searchString = searchString.trim().toLowerCase();

        if (searchString === this.state.oldSearchString) {
            // do nothing since the criteria is the same!
            return;
        }

        let keywords = searchString.split(" ");
        let selected = [];
        this.setState({
            matchedPhotos: null,
            numberOfDisplayedPhotos: 0
        });

        if (searchString === "") {
            // empty filter
            this.setState({
                matchedPhotos: allPhotos,
                oldSearchString: "",
                numberOfDisplayedPhotos: Math.min(COUNTER_INC, allPhotos.length),
                photoInViewIndex: -1
            });
            // Tracking
            ReactGA.event({
                category: "Search",
                action: "Search",
                label: "search-string: " + searchString
            });
            return;
        }

        for (let i = 0; i < allPhotos.length; i++) {
            let match = true;
            for (let j = 0; match && j < keywords.length; j++) {
                  if (keywords[j] !== "" && allPhotos[i].tags.indexOf(" " + keywords[j]) < 0) {
                    match = false;
                }
            }
            if (match) {
                selected.push(allPhotos[i]);
            }
        }

        this.setState({
            matchedPhotos: selected,
            oldSearchString: searchString,
            numberOfDisplayedPhotos: Math.min(COUNTER_INC, selected.length),
            photoInViewIndex: -1
        });

        // Tracking
        ReactGA.event({
            category: "Search",
            action: "Search",
            label: "search-string: " + searchString
        });
    }

    handleClosePhotoViewer() {
        this.setState({photoInViewIndex: -1});
        this.props.enableScrolling();

        window.history.replaceState({}, "Wilson Ng Photography", "/gallery/" + this.props.category.toLowerCase());
        //window.history.go(this.state.stateCount * -1);
        //this.setState({ stateCount: 0 });
    }

    handleViewPhoto(index) {
        if (index < 0 || index >= this.state.matchedPhotos.length) {
            return;
        }
        this.props.stopScrolling();
        this.setState({ photoInViewIndex: index });

        //Tracking
        ReactGA.modalview("/gallery/" + this.props.category.toLowerCase() + "/" + this.state.matchedPhotos[index].name);
        window.history.replaceState({}, "Wilson Ng Photography", "/gallery/" + this.props.category.toLowerCase() + "/" + this.state.matchedPhotos[index].name);

        // ReactGA.event({
        //     category: "PhotoViewer",
        //     action: "View",
        //     label: "photo-viewed: " + this.props.category.toLowerCase() + "/" + this.state.matchedPhotos[index].name
        // });
    }

    handleViewNextPhoto() {
        const nextIndex = this.state.photoInViewIndex + 1;
        if (nextIndex < this.state.numberOfDisplayedPhotos) {
            this.handleViewPhoto(nextIndex);
            //this.setState({photoInViewIndex: nextIndex});
        } else {
            if (this.state.numberOfDisplayedPhotos < this.state.matchedPhotos.length) {
                this.setState({numberOfDisplayedPhotos: this.state.numberOfDisplayedPhotos + 1});
                this.handleViewPhoto(nextIndex);
                //this.setState({photoInViewIndex: nextIndex});
            }
        }
    }

    handleViewPreviousPhoto() {
        const prevIndex = this.state.photoInViewIndex - 1;
        if (prevIndex >= 0) {
            this.handleViewPhoto(prevIndex);
            //this.setState({photoInViewIndex: prevIndex});
        }
    }

    render() {
        if (this.state.redirectTo) {
            return <Redirect to={this.state.redirectTo} />;
        }

        let loadMoreButton = "";
        let length = 0;
        if (this.state.matchedPhotos !== null) {
            length = this.state.matchedPhotos.length;
        }
        if (this.state.numberOfDisplayedPhotos < length) {
            loadMoreButton = <button className="loadMore" onClick={this.handleLoadMoreClick}>Show More</button>
        }

        let photos = [];
        if (this.state.matchedPhotos !== null) {
            photos = this.state.matchedPhotos.slice(0, this.state.numberOfDisplayedPhotos);
        }

        let viewer = "";
        if (this.state.photoInViewIndex >= 0) {
            let nextPhotoToPreload = null;
            if (this.state.photoInViewIndex + 1 < this.state.matchedPhotos.length) {
                nextPhotoToPreload = this.state.matchedPhotos[this.state.photoInViewIndex + 1];
            }
            let prevPhotoToPreload = null;
            if (this.state.photoInViewIndex > 0) {
                prevPhotoToPreload = this.state.matchedPhotos[this.state.photoInViewIndex - 1];
            }

            viewer = <ImageViewerComponent category={this.props.category} photo={this.state.matchedPhotos[this.state.photoInViewIndex]} index={this.state.photoInViewIndex} prevPhoto={prevPhotoToPreload} nextPhoto={nextPhotoToPreload} totalMatchedPhotos={this.state.matchedPhotos.length} closeButtonClick={this.handleClosePhotoViewer} nextButtonClick={this.handleViewNextPhoto} previousButtonClick={this.handleViewPreviousPhoto} />
        }

        let body = "";
        if (photos.length > 0) {
            body = photos.map((photo, index) =>
                {return <ThumbnailComponent key={index} category={this.props.category} photo={photo} index={index} imageClick={this.handleViewPhoto} />;});
        } else {
            body = <AlertBoxComponent type={ERROR} message={EMPTY_RESULT_MSG} />;
        }

        return (
            <section id="gallery-viewer-component">
                <SearchBoxComponent name="keywordFilter" placeholder="Filter by keyword(s)" search={this.handleFilterSearch} />
                <div className="header">Fine Art Gallery</div>
                <div className="content-box">
                    {body}
                </div>
                {loadMoreButton}
                {viewer}
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/widgets/Gallery/GalleryViewerComponent.js